<template>
  <div>
    <el-descriptions border>
      <el-descriptions-item label="名称">{{ productDetail.name}}</el-descriptions-item>
      <el-descriptions-item label="类别">{{ productDetail.category}}</el-descriptions-item>
      <el-descriptions-item label="价格">{{ productDetail.price || '无价格信息'}}</el-descriptions-item>
      <el-descriptions-item :span="3" label="简介">{{productDetail.brief}}</el-descriptions-item>
    </el-descriptions>
    <div v-html="productDetail.rich" class="rich">
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProductDetail',
  props: {
    productDetail: Object
  },
};
</script>

<style scoped>
.rich {
  border: #cdcdcd 1px solid;
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 10px;
  margin-top: 12px;
}
</style>
